/** ***********
*
* <dev-tools.component.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*
* All rights reserved.
**************/

import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogGenerateEventsComponent } from './dialog/dialog-generate-events/dialog-generate-events.component';
import { DialogGeneratePlanningsLineComponent } from './dialog/dialog-generate-planning-line/dialog-generate-plannings-line.component';
import { DialogGeneratePlanningsComponent } from './dialog/dialog-generate-plannings/dialog-generate-plannings';

@Component({
    selector: 'app-dev-tools',
    templateUrl: './dev-tools.component.html',
    styleUrls: ['./dev-tools.component.scss'],
    standalone: false
})
export class DevToolsComponent {

  constructor(private _dialog: MatDialog) { }

  public generateEvent() {
    this._dialog.open(DialogGenerateEventsComponent, {
        width: '60vw',
        minWidth: '300px',
    });
  }


    public generatePlanning() {
      this._dialog.open(DialogGeneratePlanningsComponent, {
            width: '60vw',
            minWidth: '300px',
        });
    }

    public generatePlanningLine() {
        this._dialog.open(DialogGeneratePlanningsLineComponent, {
            width: '60vw',
            minWidth: '300px',
        });
    }
}
